module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.content) ? void 0 : (_vm.num == '3') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "500"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-3",
    staticStyle: {
      "height": "67px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : (_vm.num == '2') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "500"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-2",
    staticStyle: {
      "height": "47px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : (_vm.num == '1') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "400"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-1",
    staticStyle: {
      "height": "24px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b15251"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableContentOverflow.vue
// module id = 1673
// module chunks = 471